import React, { useState } from "react";
import { Grid, Paper, Typography, Box, TextField, Stack, Button, Chip, Divider } from "@mui/material";

function Card({ title, subtitle, children }) {
  return (
    <Paper elevation={0} sx={{ p: 2, borderRadius: 2, border: "1px solid var(--border)", bgcolor: "var(--branco)" }}>
      <Typography sx={{ fontWeight: 900, color: "var(--cise-text)" }}>{title}</Typography>
      {subtitle && <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.3 }}>{subtitle}</Typography>}
      <Box sx={{ mt: 2 }}>{children}</Box>
    </Paper>
  );
}

export default function IntegrationsTab() {
  const [wa, setWa] = useState({ phoneId: "", token: "", verifyToken: "cise_verify", webhookUrl: "" });
  const [ai, setAi] = useState({ provider: "OpenAI", apiKey: "", model: "gpt-4o-mini", maxTokens: 800 });
  const [email, setEmail] = useState({ provider: "Resend", apiKey: "", from: "CISE <no-reply@cise.com.br>" });

  return (
    <Grid container spacing={2}>
      <Grid item xs={12} md={7}>
        <Stack spacing={2}>
          <Card title="WhatsApp Cloud API" subtitle="Credenciais e webhook">
            <GridWrap>
              <TextField label="Phone Number ID" value={wa.phoneId} onChange={(e) => setWa((p) => ({ ...p, phoneId: e.target.value }))} fullWidth size="small" />
              <TextField label="Access Token" value={wa.token} onChange={(e) => setWa((p) => ({ ...p, token: e.target.value }))} fullWidth size="small" />
              <TextField label="Verify Token" value={wa.verifyToken} onChange={(e) => setWa((p) => ({ ...p, verifyToken: e.target.value }))} fullWidth size="small" />
              <TextField label="Webhook URL" value={wa.webhookUrl} onChange={(e) => setWa((p) => ({ ...p, webhookUrl: e.target.value }))} fullWidth size="small" />
            </GridWrap>

            <Stack direction="row" justifyContent="space-between" sx={{ mt: 2 }} alignItems="center">
              <Chip label="Status: mock" sx={{ fontWeight: 900, border: "1px solid var(--border)", bgcolor: "var(--bg)" }} />
              <Button
                variant="contained"
                sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
                onClick={() => alert("Testar conexão (futuro)")}
              >
                Testar
              </Button>
            </Stack>
          </Card>

          <Card title="E-mail" subtitle="Envio de confirmações/recados (opcional)">
            <GridWrap>
              <TextField label="Provedor" value={email.provider} onChange={(e) => setEmail((p) => ({ ...p, provider: e.target.value }))} fullWidth size="small" />
              <TextField label="API Key" value={email.apiKey} onChange={(e) => setEmail((p) => ({ ...p, apiKey: e.target.value }))} fullWidth size="small" />
              <TextField label="From" value={email.from} onChange={(e) => setEmail((p) => ({ ...p, from: e.target.value }))} fullWidth size="small" />
            </GridWrap>

            <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
              <Button
                variant="contained"
                sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
                onClick={() => alert("Salvar e-mail (futuro)")}
              >
                Salvar
              </Button>
            </Stack>
          </Card>
        </Stack>
      </Grid>

      <Grid item xs={12} md={5}>
        <Card title="IA (Assistente)" subtitle="Configurações do modelo e limites">
          <GridWrap>
            <TextField label="Provider" value={ai.provider} onChange={(e) => setAi((p) => ({ ...p, provider: e.target.value }))} fullWidth size="small" />
            <TextField label="API Key" value={ai.apiKey} onChange={(e) => setAi((p) => ({ ...p, apiKey: e.target.value }))} fullWidth size="small" />
            <TextField label="Modelo" value={ai.model} onChange={(e) => setAi((p) => ({ ...p, model: e.target.value }))} fullWidth size="small" />
            <TextField label="Max tokens" type="number" value={ai.maxTokens} onChange={(e) => setAi((p) => ({ ...p, maxTokens: Number(e.target.value) }))} fullWidth size="small" />
          </GridWrap>

          <Divider sx={{ my: 2 }} />

          <Typography sx={{ fontWeight: 900 }}>Boas práticas</Typography>
          <Typography sx={{ color: "var(--cise-text-muted)", fontSize: 13, mt: 0.5 }}>
            Limite tokens, registre logs, e evite ações automáticas sem confirmação do SDR.
          </Typography>

          <Stack direction="row" justifyContent="flex-end" sx={{ mt: 2 }}>
            <Button
              variant="contained"
              sx={{ textTransform: "none", fontWeight: 900, bgcolor: "var(--cise-blue)", "&:hover": { bgcolor: "var(--cise-blue)" } }}
              onClick={() => alert("Salvar IA (futuro)")}
            >
              Salvar
            </Button>
          </Stack>
        </Card>
      </Grid>
    </Grid>
  );
}

function GridWrap({ children }) {
  return (
    <Box sx={{ display: "grid", gridTemplateColumns: { xs: "1fr", md: "1fr" }, gap: 1.5 }}>
      {children}
    </Box>
  );
}